// Opdracht re-sync — draait de Gripp→Airtable-flow (status + deliverables) opnieuw
// voor één opdrachtnummer, zonder dat je de Gripp-webhook-secret nodig hebt.
// Zelfde effect als de Gripp 'Sync Opdracht'-automation, maar met één klik.
import React, { useState } from 'react';
import {
  Box, TextField, Button, Alert, CircularProgress, Stack, Typography, Paper,
} from '@mui/material';
import SyncIcon from '@mui/icons-material/Sync';
import { BACKEND_URL } from '../../../utils/apiConfig';
import { authFetch } from '../../../utils/authHelpers';
import { SectionHeader } from '../adminSettingsCommon';

export default function OpdrachtResync() {
  const [nummer, setNummer] = useState('');
  const [busy, setBusy] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);

  const run = async () => {
    const n = nummer.trim();
    if (!n) return;
    setBusy(true);
    setError(null);
    setResult(null);
    try {
      const r = await authFetch(`${BACKEND_URL}/Api/gripp/resync-opdracht?nummer=${encodeURIComponent(n)}`, { method: 'POST' });
      const data = await r.json();
      if (!r.ok) throw new Error(data.error || 'Re-sync mislukt');
      setResult(data);
    } catch (e) {
      setError(e.message);
    } finally {
      setBusy(false);
    }
  };

  const created = result?.airtable_project?.deliverables?.created_count
    ?? result?.airtable_project?.created_count;

  return (
    <Box>
      <SectionHeader
        title="Opdracht re-sync"
        subtitle="Draait de Gripp→Airtable-sync (status + deliverables) opnieuw voor één opdrachtnummer. Handig als een sync misging — geen Gripp-webhook-secret nodig."
      />

      {error && <Alert severity="error" sx={{ mb: 2 }} onClose={() => setError(null)}>{error}</Alert>}

      <Stack direction="row" spacing={1.5} alignItems="center" sx={{ mb: 2, flexWrap: 'wrap', gap: 1 }}>
        <TextField
          size="small" label="Opdrachtnummer" placeholder="bv. 9675"
          value={nummer} onChange={(e) => setNummer(e.target.value)}
          onKeyDown={(e) => { if (e.key === 'Enter') run(); }}
          sx={{ maxWidth: 200 }}
        />
        <Button
          variant="contained" onClick={run} disabled={busy || !nummer.trim()}
          startIcon={busy ? <CircularProgress size={16} color="inherit" /> : <SyncIcon />}
          sx={{ textTransform: 'none', fontWeight: 700 }}
        >
          {busy ? 'Bezig…' : 'Re-sync'}
        </Button>
      </Stack>

      {result && (
        <Paper variant="outlined" sx={{ p: 2, bgcolor: '#f8fafc' }}>
          <Typography variant="subtitle2" fontWeight={800} sx={{ mb: 0.5 }}>
            Klaar{result.offer_status ? ` — status: ${result.offer_status}` : ''}
          </Typography>
          {typeof created === 'number' && (
            <Typography variant="body2">📦 {created} deliverable(s) aangemaakt</Typography>
          )}
          {result.warning && <Typography variant="body2" color="warning.main">⚠ {result.warning}</Typography>}
          {result.airtable_project_error && (
            <Typography variant="body2" color="error.main">Airtable-fout: {result.airtable_project_error}</Typography>
          )}
          <Typography variant="caption" color="text.secondary" component="pre"
            sx={{ mt: 1, whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
            {JSON.stringify(result, null, 2)}
          </Typography>
        </Paper>
      )}
    </Box>
  );
}
